import { founder, salon } from '../data/content'
import { policy, policyCopy } from '../data/policies'

/** Alle tokens die in beheerbare tekst mogen staan — altijd uit de actuele instellingen. */
const tokens = (): Record<string, string> => ({
  firstName: founder.firstName,
  name: founder.name,
  city: salon.city,
  years: String(policy.yearsExperience),
  experience: policyCopy.experience,
  phone: salon.phone,
  responseHours: String(policy.responseHours),
  consultName: policy.consult.name,
  consultMinutes: String(policy.consult.minutes),
  consultPrice: policyCopy.consultPrice,
  cancelHours: String(policy.cancelHours),
})

/**
 * Vult {tokens} in. Een onbekend token blijft zichtbaar staan, zodat een typfout
 * in de backend opvalt in plaats van stil te verdwijnen.
 */
export function fill(template: string, extra: Record<string, string | number> = {}): string {
  const values = { ...tokens(), ...Object.fromEntries(Object.entries(extra).map(([k, v]) => [k, String(v)])) }
  return template.replace(/\{(\w+)\}/g, (match, key: string) => values[key] ?? match)
}
